import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PreAuth } from 'src/app/classes';
import { WidgetsmanagerService } from 'src/app/services/widgetsmanager.service';
import { WsmanagerService } from 'src/app/services/wsmanager.service';
import { ChargeReversalFormComponent } from '../charge-reversal-form/charge-reversal-form.component';

@Component({
  selector: 'app-pre-auth-detail',
  templateUrl: './pre-auth-detail.component.html',
  styleUrls: ['./pre-auth-detail.component.scss'],
})
export class PreAuthDetailComponent implements OnInit {

  @Input()
  public preAuthId: number;

  @Input()
  public closeEvent: EventEmitter<void>;

  public preAuth: PreAuth;
  public chargeReversalLoading: boolean;

  constructor(
    private wsManager: WsmanagerService,
    private modalController: ModalController,
    private widgetsManager: WidgetsmanagerService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.fetchData();
    this.chargeReversalLoading = false;
  }

  fetchData(): void {
    this.wsManager.fetchSinglePreAuthorization(this.preAuthId).subscribe(preAuth => this.preAuth = preAuth);
  }

  close(): void {
    if (this.closeEvent) {
      this.closeEvent.emit();
    }
  }

  getRentalTime(): string {
    if (!this.preAuth.rentalHistory || !this.preAuth.rentalHistory.stop_time || !this.preAuth.rentalHistory.start_time) {
      return '00:00:00';
    }

    const sec_num = Math.round(new Date(this.preAuth.rentalHistory.stop_time).getTime() / 1000 - new Date(this.preAuth.rentalHistory.start_time).getTime() / 1000);
    const hours = Math.floor(sec_num / 3600);
    const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    const seconds = sec_num - (hours * 3600) - (minutes * 60);

    let hoursStr: string, minutesStr: string, secondsStr: string;
    if (hours < 10) { hoursStr = '0' + hours; } else { hoursStr = hours.toString(); }
    if (minutes < 10) { minutesStr = '0' + minutes; } else { minutesStr = minutes.toString(); }
    if (seconds < 10) { secondsStr = '0' + seconds; } else { secondsStr = seconds.toString(); }
    return hoursStr + ':' + minutesStr + ':' + secondsStr;
  }

  canCapture(): boolean {
    // Can capture only if result is APPROVED and parentId is null
    return (
      this.preAuth.status === 'PREAUTHORIZED'
    );
  }

  async capture(): Promise<void> {
    const closeEvent = new EventEmitter<void>();
    const data = new EventEmitter<{
      id: number,
      amount: number,
      reason: string
    }>();
    const popover = await this.modalController.create({
      component: ChargeReversalFormComponent,
      componentProps: {
        type: 'Capture',
        id: this.preAuth.id,
        paymentId: this.preAuth.paymentid,
        amount: this.preAuth.amount,
        closeEvent: closeEvent,
        data: data
      },
      cssClass: 'charge-reversal-modal'
    });
    closeEvent.subscribe(() => {
      popover.dismiss();
    });
    data.subscribe((data: { id: number, amount: number, reason: string }) => {
      this.chargeReversalLoading = true;
      const captureData = {
        ...data,
        preAuthId: data.id,
        parentId: this.preAuth.id
      };
      console.log('Capture data:', captureData);
      this.chargeReversalLoading = false;
      this.wsManager.executePreAuthCapture(captureData).subscribe(() => {
        this.widgetsManager.showToastMessage('success', this.translate.instant('Capture executed successfully'));
        this.chargeReversalLoading = false;
        this.fetchData();
      }, err => {
        console.log('Capture error', err);
        if (!err.error.message) {
          this.widgetsManager.showToastMessage('danger', this.translate.instant('Error executing the capture'));
        } else {
          this.widgetsManager.showToastMessage('danger', this.translate.instant(err.error.message));
        }
        this.chargeReversalLoading = false;
        this.fetchData();
      });
    });
    await popover.present();
  }
}
